import {
  Box,
  CircularProgress,
  Grid,
  Modal,
  Paper,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import deletebox from "../../Utils/Images/deletebox.png";
import editbox from "../../Utils/Images/editbox.png";
import eyebox from "../../Utils/Images/eyebox.png";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { handleDeleteQuestions } from "../../APIs/Function/Workout/Q&A/DeleteQuestion";
import CustomButton from "../Button/CustomButton";
import { Link } from "react-router-dom";
import { GetQuestions } from "../../APIs/Function/Workout/Q&A/GetQuestions";
import Loader from "../Loader/Loader";

const QandATable = ({
  setQuestionsData,
  data,
  Column1,
  Column2,
  Column3,
  Column4,
  loadinga,
}) => {
  const [modalID, setModalID] = useState("");
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleDelete = async () => {
    setLoading(true);
    await handleDeleteQuestions(modalID);
    let res = await GetQuestions();
    setQuestionsData(res.r);
    alert("Question Delete Successfully");
    setLoading(false);
    setOpen(false);
  };
  const handleModal = (id) => {
    setModalID(id);
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  return (
    <>
      {loading || loadinga ? (
        <Box sx={{ mt: "25%" }}>
          <Loader />
        </Box>
      ) : (
        <Box>
          {/* table heading */}
          <Box
            sx={{
              boxShadow: "none",
              outline: "none",
              mb: "10px",
              border: "none",
              mt: "30px",
              boxSizing: "border-box",
            }}
          >
            <Grid container>
              {/* first column */}
              <Grid item xs={0.5} md={0.5}>
                <Paper
                  sx={{
                    borderRadius: "0px",
                    border: "0.5px solid #DDDDDD",
                    boxShadow: "none",
                    height: "50px",
                    display: "flex",
                    alignItems: "center",
                    textAlign: "center",
                    justifyContent: "center",
                    bgcolor: "#E6E6E6",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "inter",
                      fontWeight: "400",
                      fontSize: "16px",

                      opacity: "85%",
                      color: "#252525",
                    }}
                  >
                    {Column1}
                  </Typography>
                </Paper>
              </Grid>

              {/* Second Column */}

              <Grid item xs={5} md={5}>
                <Paper
                  sx={{
                    borderRadius: "0px",
                    border: "0.5px solid #DDDDDD",
                    boxShadow: "none",
                    height: "50px",
                    display: "flex",
                    alignItems: "center",
                    textAlign: "center",
                    justifyContent: "center",
                    bgcolor: "#E6E6E6",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "inter",
                      fontWeight: "400",
                      fontSize: "16px",

                      opacity: "85%",
                      color: "#252525",
                    }}
                  >
                    {Column2}
                  </Typography>
                </Paper>
              </Grid>

              {/* Third Column */}

              <Grid item xs={5} md={5}>
                <Paper
                  sx={{
                    borderRadius: "0px",
                    border: "0.5px solid #DDDDDD",
                    boxShadow: "none",
                    height: "50px",
                    display: "flex",
                    alignItems: "center",
                    textAlign: "center",
                    justifyContent: "center",
                    bgcolor: "#E6E6E6",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "inter",
                      fontWeight: "400",
                      fontSize: "16px",

                      opacity: "85%",
                      color: "#252525",
                    }}
                  >
                    {Column3}
                  </Typography>
                </Paper>
              </Grid>

              {/* Fourth Column */}

              <Grid item xs={1.5} md={1.5}>
                <Paper
                  sx={{
                    borderRadius: "0px",
                    border: "0.5px solid #DDDDDD",
                    boxShadow: "none",
                    height: "50px",
                    display: "flex",
                    alignItems: "center",
                    textAlign: "center",
                    justifyContent: "center",
                    bgcolor: "#E6E6E6",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "inter",
                      fontWeight: "400",
                      fontSize: "16px",

                      opacity: "85%",
                      color: "#252525",
                    }}
                  >
                    {Column4}
                  </Typography>
                </Paper>
              </Grid>
            </Grid>
          </Box>
          {/* table data */}
          <Box
            sx={{
              border: "0.5px solid #DDDDDD",
              overflow: "auto",
              minHeight: "100px",
              maxHeight: "415px",
              "&:hover": {
                "::-webkit-scrollbar": {
                  width: "5px",
                  borderRadius: "10px",
                },
                "::-webkit-scrollbar-thumb": {
                  bgcolor: "gray",
                  borderRadius: "10px",
                },
              },
            }}
          >
            <Grid container>
              {/* first column */}
              <Grid item xs={0.5} md={0.5}>
                {data?.map((e, i) => (
                  <Paper
                    key={i}
                    sx={{
                      borderRadius: "0px",
                      border: "0.5px solid #DDDDDD",
                      boxShadow: "none",
                      height: "50px",
                      display: "flex",
                      alignItems: "center",
                      textAlign: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Typography
                      sx={{
                        fontFamily: "inter",
                        fontWeight: "400",
                        fontSize: "16px",
                      }}
                    >
                      {i + 1}
                    </Typography>
                  </Paper>
                ))}
              </Grid>

              {/* Second Column */}

              <Grid item xs={5} md={5}>
                {data.map((e, i) => (
                  <Paper
                    key={i}
                    sx={{
                      borderRadius: "0px",
                      border: "0.5px solid #DDDDDD",
                      boxShadow: "none",
                      height: "50px",
                      display: "flex",
                      alignItems: "center",
                      textAlign: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Tooltip key={i} title={e.description} arrow>
                      <Typography
                        noWrap
                        sx={{
                          fontFamily: "inter",
                          fontWeight: "400",
                          fontSize: "16px",
                          textOverflow: "ellipsis",
                          overflow: "hidden",
                          maxWidth: "90%",
                        }}
                      >
                        {e.que}
                      </Typography>
                    </Tooltip>
                  </Paper>
                ))}
              </Grid>

              {/* Third Column */}

              <Grid item xs={5} md={5}>
                {data.map((e, i) => (
                  <Paper
                    key={i}
                    sx={{
                      borderRadius: "0px",
                      border: "0.5px solid #DDDDDD",
                      boxShadow: "none",
                      height: "50px",
                      display: "flex",
                      alignItems: "center",
                      textAlign: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Typography
                      sx={{
                        fontFamily: "inter",
                        fontWeight: "400",
                        fontSize: "16px",

                        textOverflow: "ellipsis",
                        overflow: "hidden",
                        maxWidth: "100%",
                        "&:hover": {
                          overflow: "visible",
                        },
                      }}
                    >
                      {e.options?.length}
                    </Typography>
                  </Paper>
                ))}
              </Grid>

              {/* Sixth Column */}
              <Grid item xs={1.5} md={1.5}>
                {data.map((e, i) => (
                  <Paper
                    key={i}
                    sx={{
                      borderRadius: "0px",
                      border: "0.5px solid #DDDDDD",
                      boxShadow: "none",
                      height: "50px",
                      display: "flex",
                      alignItems: "center",
                      textAlign: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Box
                      sx={{
                        boxSizing: "border-box",
                        p: 1,
                        alignItems: "center",
                        display: "flex",
                        width: "100%",
                        gap: 1,
                        justifyContent: "center",
                      }}
                    >
                      <Box
                        sx={{
                          cursor: "pointer",
                          width: { xs: "50%", md: "40px" },
                          height: { xs: "50%", md: "40px" },
                        }}
                      >
                        <Link to={`/questiondetails/${e.id}`}>
                          <img
                            width={"100%"}
                            height={"100%"}
                            src={eyebox}
                            alt="logo"
                          />
                        </Link>
                      </Box>

                      <Box
                        sx={{
                          cursor: "pointer",
                          width: { xs: "50%", md: "40px" },
                          height: { xs: "50%", md: "40px" },
                        }}
                      >
                        <Link to={`/editquestion/${e.id}`}>
                          <img
                            width={"100%"}
                            height={"100%"}
                            src={editbox}
                            alt="logo"
                          />
                        </Link>
                      </Box>

                      <Box
                        sx={{
                          cursor: "pointer",
                          width: { xs: "50%", md: "40px" },
                          height: { xs: "50%", md: "40px" },
                        }}
                      >
                        <img
                          width={"100%"}
                          height={"100%"}
                          src={deletebox}
                          alt=""
                          onClick={() => handleModal(e.id)}
                        />
                        {/* Modal */}
                        <Modal open={open} onClose={handleClose}>
                          <Box
                            sx={{
                              position: "absolute",
                              top: "50%",
                              left: "50%",
                              transform: "translate(-50%, -50%)",
                              boxShadow: 24,
                              borderRadius: "20px",
                              outline: "none",
                              p: 4,
                              bgcolor: "white",
                            }}
                          >
                            <Typography variant="h6" component="h2">
                              Are you sure you want to Delete?
                            </Typography>
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              <HelpOutlineIcon
                                sx={{
                                  width: "75px",
                                  height: "100px",
                                  color: "#8ADCD9",
                                }}
                              />
                            </Box>
                            <Box
                              sx={{
                                display: "flex",
                                justifyContent: "center",
                                gap: 5,
                                mt: 2,
                              }}
                            >
                              <CustomButton onClick={() => handleDelete(e.id)}>
                                Yes
                              </CustomButton>
                              <CustomButton onClick={handleClose}>
                                No
                              </CustomButton>
                            </Box>
                          </Box>
                        </Modal>
                        {/* ............... */}
                      </Box>
                    </Box>
                  </Paper>
                ))}
              </Grid>
            </Grid>
          </Box>
        </Box>
      )}
    </>
  );
};

export default QandATable;
